module.exports = __webpack_public_path__ + "static/media/loader.87d1c5e3.svg";